import React from "react";
import styled from "styled-components";
import { star } from "../../images";
import Weight from "./Weight";

const Container = styled.div`
    position: absolute;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 0 10px 0 0;
    right: 20%;
    top: 33%;
    height: 30px;
    align-items: center;
    border-radius: 2px;
    width: 70%;
    background-color: rgba(0, 0, 0, 0.7);
`;
const Image = styled.img.attrs({
    src: star,
})`
    width: 20px;
    height: 20px;
`;

type Props = {
    doc_id: number;
    weight: number;
    onWeightChange: (doc_id: number, value: number) => void;
};

export default function FeaturedMark({
    doc_id,
    weight,
    onWeightChange,
}: Props) {
    return (
        <Container>
            <Image />
            <Weight
                value={weight}
                onChange={(e) =>
                    onWeightChange(doc_id, parseInt(e.target.value))
                }
            />
        </Container>
    );
}
